// Founder booking link. Every "Book a call" / "Connect with Founder" button uses bookingUrl(surface)
// so the utm params show which button booked a call.
const BOOKING_URL = 'https://cal.com/usekora.app/20min';

export type BookingSurface = 'floating' | 'faq' | 'contact' | 'footer' | 'get_started' | 'member_limit';

export function bookingUrl(surface: BookingSurface): string {
  const source = surface === 'get_started' ? 'kora_app' : 'usekora';
  return `${BOOKING_URL}?utm_source=${source}&utm_medium=${surface}`;
}

// Founder CTA on the in-app Get Started page. Flip to false once Kora has 10 paying customers.
export const SHOW_FOUNDER_CTA = true;
